import { useEffect, useState } from "react";
import { post } from "../../api/api";
import { sendAuthorizationRequest, sendTokenRequest } from "../../services/login";
import { getCookie } from "../../utils/cookies";

// const useLogin = (code: any) => {
const useLogin = (code: any) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    // useEffect(() => {

    //     // Francisco
    //     setTimeout(() => {
    //         const queryParams = new URLSearchParams(window.location.search);
    //         const code = queryParams.get("code");
    //         const token = getCookie("ACCESS_TOKEN") || localStorage.getItem("access_token");


    //         // Francisco - fim

    //         //if (code !== null) {
    //         if (code) {
    //             // Francisco - Adicionando setIsLoggerIN(true) - ini
    //             setIsLoggedIn(true);
    //             // fim
    //             fetchLogin(code);
    //             window.history.replaceState({}, document.title, window.location.pathname);
    //         } else if (!token) {
    //             sendAuthorizationRequest(); // inicia o fluxo de login com PKI
    //         } else {
    //             // sendAuthorizationRequest();
    //         }
    //     }, 200);

    // }, []);

    useEffect(() => {
        if (code !== null) {
            fetchLogin(code);
        } else {
            sendAuthorizationRequest();
        }
    }, []);

    const fetchLogin = (code: any) => {

        sendTokenRequest(code).then(response => {
            setTimeout(() => {
                window.location.href = window.location.origin + '/stapp/home';
            }, 300);

        }).catch((error => {
            sendAuthorizationRequest();
        })).finally(() => setIsLoggedIn(false));
    }

    return {};
}

export default useLogin;